import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

export default function StepHint({ icon: Icon, title, description }) {
  return (
    <Container>
      <IconWrapper>
        <Icon size={18} />
      </IconWrapper>
      <TextContent>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TextContent>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing[3]};
  padding: ${theme.spacing[3]} ${theme.spacing[4]};
  background: ${theme.colors.infoLight};
  border: 1px solid ${theme.colors.infoBorder};
  border-radius: ${theme.radii.md};
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${theme.colors.info};
  margin-top: 1px;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Title = styled.span`
  font-size: ${theme.typography.sm};
  font-weight: ${theme.typography.medium};
  color: ${theme.colors.textPrimary};
`;

const Description = styled.span`
  font-size: ${theme.typography.sm};
  color: ${theme.colors.textSecondary};
  line-height: ${theme.typography.snug};
`;
